module.exports = __webpack_public_path__ + "img/icon_success.65b7a4b3.png";